import React from 'react';

/**
 * PageSkeleton
 * High-performance skeleton UI placeholder for Telegram Mini App route transitions & lazy loading.
 * Prevents Layout Shift (CLS) by pre-allocating the layout dimensions before chunks load.
 */
export function PageSkeleton(): React.JSX.Element {
  return (
    <div 
      className="p-4 space-y-4 w-full max-w-[500px] mx-auto animate-fade-in"
      style={{
        boxSizing: 'border-box',
        minHeight: 'calc(100dvh - 120px)',
      }}
    >
      {/* Header bar skeleton */}
      <div className="flex justify-between items-center h-12">
        <div className="skeleton-box w-36 h-6 rounded-lg" />
        <div className="skeleton-box w-20 h-8 rounded-xl" />
      </div>

      {/* Primary KPI / Feature cards grid skeleton */}
      <div className="grid grid-cols-2 gap-3 my-4">
        <div className="skeleton-box h-24 rounded-2xl" />
        <div className="skeleton-box h-24 rounded-2xl" />
      </div>

      {/* Content list skeleton */}
      <div className="space-y-3 pt-2">
        <div className="skeleton-box h-5 w-28 rounded" />
        <div className="skeleton-box h-20 w-full rounded-2xl" />
        <div className="skeleton-box h-20 w-full rounded-2xl" />
        <div className="skeleton-box h-20 w-full rounded-2xl" />
      </div>
    </div>
  );
}

export default PageSkeleton;
